<div class="modal-container">
  <ng-content></ng-content>
</div>
